import { autoMount } from '../../../utils/autoMount';
import { SpecialShow } from '../../../components/pages/specialShow';

autoMount({ SpecialShow });
